import Vue from 'vue';
import VueI18n, { LocaleMessages } from 'vue-i18n';

Vue.use(VueI18n);

export default new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'es-ES',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'es-ES',
    messages: loadLocaleMessages(),
    dateTimeFormats: {
        'en-GB': {
            short: {
                year: 'numeric', month: 'numeric', day: 'numeric',
            },
            long: {
                year: 'numeric', month: 'short', day: 'numeric',
                weekday: 'short', hour: 'numeric', minute: 'numeric',
            },
            compact: {
                year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
            }
        },
        'es-ES': {
            short: {
                year: 'numeric', month: 'numeric', day: 'numeric',
            },
            long: {
                year: 'numeric', month: 'short', day: 'numeric',
                weekday: 'short', hour: 'numeric', minute: 'numeric',
            },
            compact: {
                year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
            }
        },
        'eu-ES': {
            short: {
                year: 'numeric', month: 'numeric', day: 'numeric',
            },
            long: {
                year: 'numeric', month: 'short', day: 'numeric',
                weekday: 'short', hour: 'numeric', minute: 'numeric',
            }, compact: {
                year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
            }
        },
        'ca-ES-valencia': {
            short: {
                year: 'numeric', month: 'numeric', day: 'numeric',
            },
            long: {
                year: 'numeric', month: 'short', day: 'numeric',
                weekday: 'short', hour: 'numeric', minute: 'numeric',
            },
            compact: {
                year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit',
            }
        },
    },
    numberFormats: {
        'en-GB': {
            currency: {
                style: 'currency', currency: 'EUR', currencyDisplay: 'symbol', minimumFractionDigits: 2, maximumFractionDigits: 2,
            }
        },
        'es-ES': {
            currency: {
                style: 'currency', currency: 'EUR', currencyDisplay: 'symbol', minimumFractionDigits: 2, maximumFractionDigits: 2,
            }
        },
        'eu-ES': {
            currency: {
                style: 'currency', currency: 'EUR', currencyDisplay: 'symbol', minimumFractionDigits: 2, maximumFractionDigits: 2,
            }
        },
        'ca-ES-valencia': {
            currency: {
                style: 'currency', currency: 'EUR', currencyDisplay: 'symbol', minimumFractionDigits: 2, maximumFractionDigits: 2,
            }
        }
    }
});

function loadLocaleMessages(): LocaleMessages {
    const locales = require.context('../resources', true, /[A-Za-z0-9-_,\s]+\.json$/i);
    const messages: LocaleMessages = {};

    locales.keys().forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });

    return messages;
}
